import './notification.scss';

function showNotification(element, options = {}) {
	const snackBar = new window.MDCSnackbar(element);

	snackBar.timeoutMs = options.timeout || 10000;
	snackBar.open();
}

function createNotification(data) {
	try {
		const tmp = document.createElement('div');
		const html = window.LN.templates.notification(data);

		tmp.innerHTML = html.trim();

		const dialog = document.querySelector('dialog[open]');
		const notification = (dialog || document.body).appendChild(tmp.firstChild);

		return notification;
	} catch (err) {
		console.log(err);

		return null;
	}
}

const snackbars = document.querySelectorAll('[data-init="snackbar"]');

snackbars.forEach(showNotification);

// Pseudo-persistent notifications
const notifications = document.querySelectorAll('[data-init="notification"]');

notifications.forEach(element => {
	const close = element.querySelector('[data-notification="close"]');

	if (close) {
		close.addEventListener('click', async () => {
			element.parentNode.removeChild(element);

			if (close.dataset.notificationCloseAction) {
				await fetch(close.dataset.notificationCloseAction, {
					method: 'POST'
				});
			}
		});
	}
});

export { showNotification, createNotification };
